import React from "react";
import { useFormContext } from "react-hook-form";
import {
    ContentSection,
    FailureSeverity,
    ValidationFailure,
    mapToDropdownOption,
    FormDropdown
} from "sprint-common-web";
import { FormFailureMessages } from "sprint-common-web/src/components/forms/FormFailureMessages";

import { useCreateFileRecordFormOptions } from "../hooks/useCreateFileRecordFormOptions";

export interface CreateAudioFileRecordLanguagesFormProps {
    validationFailures?: ValidationFailure[];
}

export const CreateAudioFileRecordLanguagesForm: React.FC<CreateAudioFileRecordLanguagesFormProps> = ({
    validationFailures
}: CreateAudioFileRecordLanguagesFormProps) => {
    const { dubbings, areOptionsLoading } = useCreateFileRecordFormOptions();

    const { control, errors } = useFormContext();

    return (
        <ContentSection
            header="Languages"
            isLoading={areOptionsLoading}
            style={{ minHeight: "39vh", marginBottom: "2vh" }}
        >
            <FormDropdown
                label="Soundtrack"
                name="audioSoundtrack"
                options={dubbings.map((dub) => mapToDropdownOption(dub))}
                control={control}
                errors={errors}
            />
            <FormFailureMessages failures={validationFailures ?? []} severity={FailureSeverity.Error} />
        </ContentSection>
    );
};
